import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import InfoIcon from "@/icons/common/info-icon.vue";
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  text: {
    type: String,
    default: "",
  },
},
  setup(__props) {

const show = ref(false);
const visible = ref(false);
let timeout: ReturnType<typeof setTimeout> | null = null;



const onHover = () => {
  if (timeout != null) {
    clearTimeout(timeout);
  }
  timeout = setTimeout(() => {
    if (!show.value) {
      show.value = true;
      setTimeout(() => {
        visible.value = true;
      }, 50);
    }
  }, 300);
};
const onHide = () => {
  if (timeout != null) {
    clearTimeout(timeout);
    timeout = null;
  }
  if (visible.value) {
    visible.value = false;
    setTimeout(() => {
      show.value = false;
    }, 200);
  } else {
    visible.value = false;
    show.value = false;
  }
};
const classObject = () => {
  return { normal: true, visible: visible.value };
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "info-tooltip",
    onMouseenter: onHover,
    onMouseleave: onHide
  }, [
    _createVNode(InfoIcon),
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass(["info-tooltip__text", classObject()])
    }, _toDisplayString(__props.text), 3), [
      [_vShow, show.value]
    ])
  ], 32))
}
}

})